import React from "react";
import styled from "styled-components";

const StyledTitle = styled.h1`
    color: #00725f;
    font-family: "Nexa";
    font-style: normal;
    font-weight: bold;
    font-size: 30px;
    line-height: 35px;
`;

interface Props {
    children: React.ReactNode;
}

const Title = ({ children }: Props): React.ReactElement => {
    return <StyledTitle> {children} </StyledTitle>;
};

export default Title;
